<template>
  <AppTooltip
    :disabled="disabled || !room.displayName"
    placement="top"
    :handleResize="false"
    boundariesElement="window"
  >
    <slot></slot>

    <template #tooltip>
      <table class="table my-0">
        <tr class="tr">
          <td class="py-1 align-middle border-0"><AppIcon name="meeting_room" :size="19" class="align-middle" /></td>
          <td class="py-1 align-middle border-0">Room</td>
          <td class="py-1 align-middle border-0">{{ room.displayName }}</td>
        </tr>
        <tr class="tr">
          <td class="py-1 align-middle"><AppIcon name="style" :size="19" class="align-middle" /></td>
          <td class="py-1 align-middle">Type</td>
          <td class="py-1 align-middle">{{ room.type }}</td>
        </tr>
        <tr class="tr">
          <td class="py-1 align-middle"><AppIcon name="group" :size="19" class="align-middle" /></td>
          <td class="py-1 align-middle">Capacity</td>
          <td class="py-1 align-middle">{{ room.capacity }}</td>
        </tr>
        <tr class="tr">
          <td class="py-1 align-middle"><AppIcon name="settings" :size="19" class="align-middle" /></td>
          <td class="py-1 align-middle">Features</td>
          <td class="py-1 align-middle">{{ (room.features || []).join(', ') }}</td>
        </tr>
        <tr class="tr">
          <td class="py-1 align-middle"><AppIcon name="home" :size="19" class="align-middle" /></td>
          <td class="py-1 align-middle">Building</td>
          <td class="py-1 align-middle">{{ buildingById(room.buildingId).displayName }}</td>
        </tr>
      </table>
    </template>
  </AppTooltip>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    room: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: { ...mapGetters([ 'buildingById' ]) },
}
</script>
